<main class="minhas_compras">
  <h1>Minhas compras</h1> 

  <p *ngIf="pedidos().length > 0">Bem-vindo, {{ pedidos()[0].nome_responsavel }}!</p>

  <div class="loading-overlay" *ngIf="isLoading()">
    <mat-spinner></mat-spinner>
  </div>
  
  <p *ngIf="error" class="error-message">{{ error }}</p>

  <section class="pedidos-container" *ngIf="!isLoading() && !error">
    <mat-accordion class="expansion-panel-headers-align">
      <mat-expansion-panel 
        *ngFor="let pedido of pedidos()"
        (opened)="panelOpenState = true"
        (closed)="panelOpenState = false"
      >
        <mat-expansion-panel-header>
          <mat-panel-title>
            #{{ pedido.id_pedido }}
            <span class="status-chip" [ngClass]="getStatusClass(pedido.status_pedido.descricao)">
              {{ pedido.status_pedido.descricao }}
            </span>
          </mat-panel-title>
          <mat-panel-description>
          {{ formatarData(pedido.data_pedido) }}
          <span class="price"><strong>R$ {{ pedido.valor_total_pedido | number:'1.2-2' }}</strong></span>
        </mat-panel-description>
        </mat-expansion-panel-header>
        
        <div class="order-container">
          <div class="order-header">
            <p class="header-text">Itens do Pedido ({{ pedido.itens.length }} itens)</p>
          </div>
          <div class="order-list">
            <div class="list-item" *ngFor="let item of pedido.itens">
              <div class="item-details">
                <p class="item-name">{{ item.produto.desc_produto }}</p>
                <p class="item-description">{{ item.dependente.nome_dependente }}</p>
              </div>
              <p class="item-price">R$ {{ item.valor_unitario| number:'1.2-2' }}</p>
            </div>
            <hr class="divider">
          </div>
          <div class="order-footer">
            <p class="total-label">Total:</p>
            <p class="total-price">R$ {{ pedido.valor_total_pedido | number:'1.2-2' }}</p>
          </div>
        </div>
      </mat-expansion-panel>
    </mat-accordion>

  </section>
</main>
